<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
          :bordered="false"
          class="header-solid h-full"
          :bodyStyle="{ padding: 0 }"
        >
          <template #title>
            <a-row type="flex" align="middle">
              <a-col :span="24" :md="12">
                <h5 class="font-semibold m-0">
                  جدول سانس های {{ info.title }}
                </h5>
                <br>
                <span>تعداد افراد دعوت شده : {{info.count_invites}}</span>

                &nbsp;
                &nbsp;
                &nbsp;
                <span>تعداد حاضرین : {{info.count_presents}}</span>

              </a-col>
              <a-col
                :span="24"
                :md="12"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <a-button
                  :disabled="
                    new Date(info.start_date).getTime() <= new Date().getTime()
                  "
                  class="btn-outline-purple"
                  icon="plus"
                  @click="isHidden = !isHidden"
                >
                  افزودن
                </a-button>
                &nbsp;
              </a-col>
            </a-row>
          </template>

          <b-card
            style="margin:20px; !important ; border:none;"
            v-if="isHidden"
          >
            <form @submit.prevent="addData($event)">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group text-right">
                    <label for="">ساعت شروع</label>
                    <input
                      v-model="sans.start_hour"
                      name="start_hour"
                      type="number"
                      class="form-control"
                    />
                  </div>
                  <input name="seminar_id" type="hidden" :value="info.id" />
                </div>
                <div class="col-md-6">
                  <div class="form-group text-right">
                    <label for="">ساعت پایان</label>
                    <input
                      v-model="sans.end_hour"
                      name="end_hour"
                      type="number"
                      class="form-control"
                    />
                  </div>
                </div>

                <div class="mt-1">
                  <button
                    type="submit"
                    class="btn btn-fill btn-outline-success"
                  >
                    ذخیره
                  </button>
                </div>
              </div>
            </form>
          </b-card>

          <a-row
            style="justify-content: center; display: flex"
            v-if="$store.state.loading"
          >
            <template>
              <div>
                <a-spin />
              </div>
            </template>
          </a-row>
          <div v-else>
            <section class="w-100 p-4 text-center">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">شناسه</th>
                      <th scope="col">ساعت شروع</th>
                      <th scope="col">ساعت پایان</th>
                      <th scope="col">لیست تماس ها</th>
                      <th scope="col">تعداد حاضرین</th>
                      <th scope="col">عملیات</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="sans in info.sans">
                      <th scope="row">#{{ sans.id }}</th>
                      <td>
                        <b-badge variant="light" class="text-dark">{{
                          sans.start_hour
                        }}</b-badge>
                      </td>
                      <td>
                        <b-badge variant="light" class="text-dark">{{
                          sans.end_hour
                        }}</b-badge>
                      </td>
                      <td>
                        <b-badge variant="light" class="text-dark">{{
                          sans.count_accepts
                        }}</b-badge>
                      </td>
                      <td>
                        <b-badge variant="light" class="text-dark">{{
                          sans.count_presents
                        }}</b-badge>
                      </td>
                      <td>
                        <a-button
                          icon="user"
                          type="link"
                          :href="'/seminars/guests/' + sans.id"
                          >مهمانان</a-button
                        >
                        &nbsp;

                        <a-button
                          icon="gift"
                          type="link"
                          :href="'/seminars/gifts/' + sans.id"
                          >قرعه کشی</a-button
                        >
                        &nbsp;

                        <a-button
                          target="_blank"
                          :href="
                            $store.state.baseUrl+'/sans-export/' + sans.id
                          "
                        >
                          <a-icon type="upload" /> خروجی اکسل دعوت شده ها
                        </a-button>
                        <!-- &nbsp;
                        <a-button
                          icon="delete"
                          type="link"
                          :disabled="
                            new Date(info.start_date).getTime() <=
                            new Date().getTime()
                          "
                          @click="deleteRow(sans.id)"
                        ></a-button> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      visible: false,
      isHidden: false,
      total_count: 0,
      present_count: 0,
      info: {},
      sans: {
        start_hour: "",
        end_hour: "",
      },
    };
  },

  methods: {
    async getData() {
      let _this = this;
      axios
        .get("/seminars/single/" + this.$route.params.id)
        .then(function (response) {
          _this.$store.state.loading = false;
          _this.info = response.data;
          console.log(response)
        })
        .catch(function (err) {
          _this.$root.handleAxiosError(err);
        });
    },

    addData(event) {
      let _this = this;
      let data = new FormData(event.target);
      _this.$root.loading = true;
      axios
        .post("/seminars/sans", data)
        .then(function (response) {
          _this.$root.loading = false;
          _this.sans = {};
          _this.$toast.success(" سانس سمینار با موفقیت افزوده شد");
          _this.getData();
        })
        .catch(function (err) {
          _this.$root.loading = false;
          _this.$root.handleAxiosError(err);
        });
    },
    deleteRow(id) {
      this.$swal({
        title: "آیا از حذف اطلاعات اطمینان دارید؟",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "بله",
        denyButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          let _this = this;
          axios
            .get(`seminars/sans/delete/${id}`)
            .then(function (response) {
              _this.getData();
              _this.$toast.success("با موفقیت حذف شد.");
            })
            .catch(function (err) {
              _this.$root.handleAxiosError(err);
            });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scope>
.pagination {
  display: flex;
  justify-content: center;
  margin: 15px;
}
</style>
